import { Hand, LucideIcon, RefreshCw } from 'lucide-react';

import { ControlTypeEnum } from '../../../shared/models';

export const controlTypeDefinitions: Record<
  ControlTypeEnum,
  { icon: LucideIcon; label: string; longLabel: string; description: string }
> = {
  [ControlTypeEnum.manual]: {
    icon: Hand,
    label: 'Manual',
    longLabel: 'Manual',
    description: 'Human action required',
  },
  [ControlTypeEnum.automatic_logic]: {
    icon: RefreshCw,
    label: 'Logic',
    longLabel: 'Automated with logic',
    description: 'Defined with conditional operators',
  },
  [ControlTypeEnum.automatic_code]: {
    icon: RefreshCw,
    label: 'Code',
    longLabel: 'Automated with code',
    description: 'Generate code with AI',
  },
};

export const controlTypeCategoriesDefinitions: Record<
  string,
  { label: string; icon: LucideIcon; types: ControlTypeEnum[] }
> = {
  manual: {
    label: 'Manual',
    icon: Hand,
    types: [ControlTypeEnum.manual],
  },
  automated: {
    label: 'Automated',
    icon: RefreshCw,
    types: [ControlTypeEnum.automatic_code, ControlTypeEnum.automatic_logic],
  },
};
